import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldByIdVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type ApiWorldById = { world: { chainId: ChainId, createdAt: string, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { username: string | null, name: string | null, profileImageUrl: string | null, publicKey: Address } } | null };



export const ApiWorldByIdDocument = /*#__PURE__*/ `
    query WorldById($id: Int!) {
  world(id: $id) {
    chainId
    createdAt
    id
    name
    slug
    moderationStatus
    curator {
      publicKey: accountAddress
      username
      name
      profileImageUrl
    }
    imageUrl
    coverUrl
    takeRateInBasisPoints
  }
}
    `;

export const useWorldById = <
      TData = ApiWorldById,
      TError = ClientError
    >(
      variables: ApiWorldByIdVariables,
      options?: Omit<UseQueryOptions<ApiWorldById, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldById, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldById, TError, TData>(
      {
    queryKey: ['WorldById', variables],
    queryFn: apiFetcher<ApiWorldById, ApiWorldByIdVariables>(ApiWorldByIdDocument, variables),
    ...options
  }
    )};

useWorldById.getKey = (variables: ApiWorldByIdVariables) => ['WorldById', variables];

export const useInfiniteWorldById = <
      TData = InfiniteData<ApiWorldById>,
      TError = ClientError
    >(
      variables: ApiWorldByIdVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldById, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldById, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldById, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldById.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldById, ApiWorldByIdVariables>(ApiWorldByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldById.getKey = (variables: ApiWorldByIdVariables) => ['WorldById.infinite', variables];


useWorldById.fetcher = (variables: ApiWorldByIdVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldById, ApiWorldByIdVariables>(ApiWorldByIdDocument, variables, options);
